import { getRuFormatDateString } from 'shared/lib';

import {
  ParamsContainer,
  ReportInfoContainer,
  ReportParam,
  ReportTitle,
} from './styles';

interface ReportInfoProps {
  title: string;
  dateFromParam: string | null;
  dateToParam: string | null;
}

export function ReportInfo({
  title,
  dateFromParam,
  dateToParam,
}: ReportInfoProps) {
  const currentDate = getRuFormatDateString();

  const dateFrom =
    dateFromParam === null ? currentDate : getRuFormatDateString(dateFromParam);
  const dateTo =
    dateToParam === null ? currentDate : getRuFormatDateString(dateToParam);

  return (
    <ReportInfoContainer>
      <ReportTitle>{title}</ReportTitle>
      <ParamsContainer>
        <ReportParam>{`Период от и до: ${dateFrom} - ${dateTo}`}</ReportParam>
        <ReportParam>{`Дата отчёта: ${currentDate}`}</ReportParam>
      </ParamsContainer>
    </ReportInfoContainer>
  );
}
